import axios from 'axios';
import { CORE_SERVICES_API_URL } from 'config/constants';
import type { PropertyInfoAddressDTO } from 'entities/property/property.models';
import type { GetPropertyBasicInfoPayload } from './property.models';

const coreServicesApiUrl = CORE_SERVICES_API_URL;
const propertiesV2 = `${coreServicesApiUrl}/v2/properties`;

export const getPropertyBasicInfo = async ({ property_id }: GetPropertyBasicInfoPayload) => {
  const response = await axios.get<PropertyInfoAddressDTO>(`${propertiesV2}/${property_id}`);
  return response.data;
};
